export function debounce<T, A extends unknown[]>(func: (this: T, ...args: A) => void | Promise<void>, timeout = 300) {
    let timer: NodeJS.Timeout;
    return function (this: T, ...args: A) {
        clearTimeout(timer);
        timer = setTimeout(() => { void func.apply(this, args); }, timeout);
    };
}
